import { render } from "./MealTutorial.vue?vue&type=template&id=be51a8c2&ts=true"
import script from "./MealTutorial.vue?vue&type=script&lang=ts"
export * from "./MealTutorial.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__